import { Component, AfterViewInit, OnInit, ChangeDetectorRef, Renderer } from '@angular/core';

import {Title } from '@angular/platform-browser';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';
import { MdSnackBar } from '@angular/material';

import { StorageService } from '../../services/storage.service';
import { RestService } from '../../services/rest.service';
import { PrintService } from 'app/print/print.service';

import 'rxjs/add/operator/toPromise';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'importDE',
  providers: [StorageService, RestService, PrintService],
  templateUrl: './importDE.component.html',
  styleUrls: ['./importDE.component.scss']
})
export class ImportDEComponent implements AfterViewInit, OnInit {

  parcelCode: string;
  scannedValue: string = null;
  parcelCount: number = 0;

  storages: any[] = [];
  private storage: any = null;
  loadedParcel: boolean = false;
  status: string = null;
  reference: string = null;
  tracking: any;
  orders: any[];
  order: any;

  private mainContainer: any = null;
  mainContainerName: string;
  loadedMainContainer: boolean = false;  
  importCountry: string = null;
  lineHaul: any;
  relabel: string = null;

  filterTitle: string;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _restService: RestService,
    private _printService: PrintService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    private _snackBarService: MdSnackBar,
    public renderer: Renderer) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('ImportDE');
    this.load();
    this._route.url.subscribe((url: any) => {
      this.importCountry = (url.length > 1 ? url[1].path : '');
    });

  }


  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('import.list');
      this.loadFilter('All import');    
    } catch (error) {

    } finally {
      this._loadingService.resolve('import.list');
    }
  }

  async loadMainContainer(mainContainerName: string): Promise<void> {
    try {
      //validate container: it must exist
      this.mainContainer = await this._storageService.getContainer(mainContainerName).toPromise();
      if (this.mainContainer.containerStatus == 'OPEN') {
        // Check that the line_haul.workflow matches the country
        let addInfoItem: any = this.mainContainer.addInfo.find(element => element.keyValue == 'line_haul');
        // get lineHaul by name
        this.lineHaul = await this._storageService.getLineHaulByNameAndWorkflow(addInfoItem.textValue, 'import'+ this.importCountry).toPromise();
        if (!this.lineHaul) {
          this._dialogService.openAlert({ message: 'Line haul is not found'});
          this.loadedMainContainer = false;
        } else {        
          this.mainContainerName = this.mainContainer.name;
          this.loadedMainContainer = true;
          this.storages = await this._storageService.getContainerNameParcels(mainContainerName).toPromise();
          this.parcelCount = this.storages.reduce((total, storage) => total + storage.itemCount, 0);
        }
      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.mainContainer.containerStatus });
        this.loadedMainContainer = false;
      }
    } catch (error) {
      //container does not exist
      this.loadedMainContainer = false;
    } finally {
    }
  }

  isMainContainerLoaded() {
    return this.loadedMainContainer;
  }

  async loadValue(value: string): Promise<void> {
    
      if (this.mainContainer.containerStatus == 'OPEN') {
        try {
          // clear loaded values
          this.clearForm();
          // load the new parcel
          await this.loadParcel(value);
          this.scannedValue = null;
          if(this.loadedParcel) {
            this.parcelCount++;
          }
        } catch (error) {
            this.status = 'none';
            this.loadedParcel = false;
        }
      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.mainContainer.containerStatus });
        this.loadedMainContainer = false;
        this.loadedParcel = false;
        this.scannedValue = null;
      }
  }

  async loadParcel(value: string): Promise<void> {
    try {
      await this.getParcel(value);
      if (!this.storage) { // parcel not stored
        this.status = 'NoData';
        this.loadedParcel = false;
        this.reference = null;
        this.parcelCode = value;
      } else if ( this.relabel == 'RELABEL') {
        this.status = 'ForRelabel';
        this.parcelCode = value;
        this.reference = this.storage.reference;
        this.loadedParcel = true;
      } else if (this.relabel == 'RELABEL_FAILED') {
        this.status = 'RelabelFailed';
        this.parcelCode = value;
        this.reference = null;
        this.loadedParcel = false;
      } else if (this.relabel == 'NO_RELABEL') {
        this.status = 'OK';
        this.parcelCode = value;
        this.reference = this.storage.reference;
        this.loadedParcel = true;
      } else if (this.relabel == 'PRINT') { // Tracking Number
        this.status = 'PrintLabel';
        this.parcelCode = value;
        this.reference = this.storage.reference;
        this.loadedParcel = true;
      }
    } catch (error) {
      this.status = 'none';
      this.loadedParcel = false;
    } finally {
    }
  }

  async getStorageStatus(trackingNumber: string): Promise<any> {
    return await this._storageService.getStorageStatus(trackingNumber).toPromise();
  }

  async getParcel(reference: string): Promise<void> {
    try{
      // checkRelabeling =>
      // get tracking
      // get trackingItemInfo.routingInformation
      // get order
      // checks if relabeling needed

      // POSSIBLE RETURNED VALUES in relabelResponse.result
      // TRACKINGNUMBER (XXXX): relabeling needed, second scan OK (new label and tracking generated). Get and print label
      // RELABEL_FAILED: relabeling needed, second scan failed.
      // NO_RELABEL: relabeling not needed.


      let storageStatus: any = await this._storageService.getStorageStatus(reference).toPromise();
      if (storageStatus) {
        this.relabel = storageStatus.storageStatus;
      }

      
      if (this.relabel != null) {

        let storage = {
          itemCount: 1,
          containerName: this.mainContainerName,
          reference: storageStatus.reference,
          workflowStatus: 'TAXATION',
          storeUser: null,
          storeDate: new Date(),
          businessKey: storageStatus.orderBusinessKey,
          projectId: storageStatus.projectId
        }
      
        if (this.relabel == 'RELABEL') {
          // CASE 5)
          // CASE 6)
          storage.containerName = null;
          this.storage = storage;
          // triggers
          // update status from RELABLE to PRINT 
          this._storageService.calculateStorageStatus(storageStatus.orderBusinessKey, reference).toPromise();
        } else if (this.relabel == 'NO_RELABEL') {      
          if (!storageStatus.routingInformation || storageStatus.routingInformation == this.lineHaul.name) {
            // CASE 1)
            this.storage = storage;
            this._storageService.createStorage(storage).toPromise();
            // create event (to be able to track where the parcel was initially stored)
            let restEvent = {
              eventDate: new Date(),
              source: 'INTERNAL',
              reference: storageStatus.reference,
              trackingNumber: reference,
              status: 'ARRIVED_HUB',
              description: "storage service : store to container (" + this.mainContainerName + ")",
              internal: true
            }
            this._restService.createEvent(restEvent).toPromise();
          } else {
            // CASE 4)
            this._dialogService.openAlert({ message: 'Container Line haul (' + this.lineHaul.name + ') does not match parcel routing information (' + storageStatus.routingInformation + ')' });
          }

        } else if (this.relabel == 'PRINT') {
          // TRIGGER THE GENERATION OF THE NEW LABEL HERE
          let relabelingResponse = await this._restService.doRelabeling(storageStatus.orderBusinessKey, reference).toPromise();
          let relabelingResult = relabelingResponse.relabelingResults[0];
          // to avoid NO DATA response
          this.storage = storage;

          // get and print label
          await this._restService.getLabel(relabelingResult.trackingNumber).toPromise();
          await this.sleep(1000);
          await this._printService.print('labelPrinter', relabelingResult.trackingNumber).toPromise();
          // check that package with new label is being loaded to the correct container       
          
          if (!relabelingResult.routingInformation || relabelingResult.routingInformation != this.lineHaul.name) {
            // CASE 8
            this._dialogService.openPrompt({ message: "Enter a container that matches the line haul " + relabelingResult.routingInformation})
              .afterClosed().subscribe(
                data => {
                  storage.containerName = data
                  this.storage = storage;
                  this._storageService.createStorage(storage).toPromise();
                  // create event (to be able to track where the parcel was stored)
                  let restEvent = {
                    eventDate: new Date(),
                    source: 'INTERNAL',
                    reference: relabelingResponse.reference,
                    trackingNumber: relabelingResult.trackingNumber,
                    status: 'ARRIVED_HUB',
                    description: "storage service : store to container (" + storage.containerName + ")",
                    internal: true
                  }
                  this._restService.createEvent(restEvent).toPromise();
                  try {
                    this._storageService.resolveException(storageStatus.trackingNumber, storageStatus.reference).toPromise();
                  } catch (error) {
                    console.log('Cannot resolve exception!'); // exception may not exist
                  }
                }
            );    
          } else {
            // CASE 7
            storage.containerName = this.mainContainerName;
            this.storage = storage;
            this._storageService.createStorage(storage).toPromise();
            // create event (to be able to track where the parcel was stored)
            let restEvent = {
              eventDate: new Date(),
              source: 'INTERNAL',
              reference: relabelingResponse.reference,
              trackingNumber: relabelingResponse.trackingNumber,
              status: 'ARRIVED_HUB',
              description: "storage service : store to container (" + storage.containerName + ")",
              internal: true
            }
            this._restService.createEvent(restEvent).toPromise();
            try {
              this._storageService.resolveException(storageStatus.trackingNumber, storageStatus.reference).toPromise();
            } catch (error) {
              console.log('Cannot resolve exception!'); // exception may not exist
            };
          }
        }

      } else {
        // CASE 2)
        console.log('No data!');
        this.storage = null;

        // create event (to be able to track that the parcel arrived)
        let restEvent = {
          eventDate: new Date(),
          source: 'INTERNAL',
          reference: reference,
          trackingNumber: reference,
          status: 'ARRIVED_HUB',
          description: "no data",
          internal: true
        }
        this._restService.createEvent(restEvent).toPromise();

        // create storage exception NOT_FOUND with status PENDING
        let exception = {
          reference : null,
          code : reference, // tracking number
          exceptionDate : new Date(),
          exceptionType : 'NOT_FOUND',
          exceptionStatus : 'PENDING',
          containerName : null
        }
        this._storageService.sendToException(exception).toPromise();

      }
        
    } catch (error) {
        console.log('Cannot get parcel!');
        this.storage = null;

        // CASE 2)
        console.log('No data!');

        // create event (to be able to track that the parcel arrived)
        let restEvent = {
          eventDate: new Date(),
          source: 'INTERNAL',
          reference: reference,
          trackingNumber: reference,
          status: 'ARRIVED_HUB',
          description: "no data",
          internal: true
        }
        this._restService.createEvent(restEvent).toPromise();

        // create storage exception NOT_FOUND with status PENDING
        let exception = {
          reference : null,
          code : reference, // tracking number
          exceptionDate : new Date(),
          exceptionType : 'NOT_FOUND',
          exceptionStatus : 'PENDING',
          containerName : null
        }
        this._storageService.sendToException(exception).toPromise();

    } finally {
    }
  }

  sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  getStatus() {
    return this.status;
  }

  keytab(event, from: string){ 
    let innerText: string = 'Scan parcel'; // move cursor to Scan parcel at the end
    if (from == 'mainContainerName') {
      this.loadMainContainer(this.mainContainerName);
    } else if (from == 'scannedValue') {
      this.loadValue(this.scannedValue);
    }

    let path = event.composedPath();
    let element = path[5]; // naviagte to md-card-content

    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == innerText) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }

  isParcelLoaded() {
    return this.loadedParcel;
  }

  closeContainer() {
    this._closeContainer();
  }

  async _closeContainer() {
    this.mainContainer.containerStatus = 'CLOSED';
    this.mainContainer.addInfo = [];
      if (this.lineHaul.name) {
        let item: any = {}; item.keyValue = 'line_haul'; item.textValue = this.lineHaul.name; this.mainContainer.addInfo.push(item);}
    await this._storageService.updateContainer(this.mainContainer, true).toPromise();
    this._snackBarService.open('Container closed', 'OK');
  }

  goBack(): void {
    this.clearForm();
    this.mainContainer = null;
    this.mainContainerName = null;
    this.loadedMainContainer = false;
    this.lineHaul = null; 
    this._router.navigate(['/stockup/import/'+this.importCountry]);
  }

  clearForm() {
    this.parcelCode = '';
    this.storage = null;
    this.status = null;
    this.reference = null;
    this.relabel = null;
    //this.load();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/import/importDE/importDE.component.ts